import { render, staticRenderFns } from "./TheAlgorithm.vue?vue&type=template&id=342f5891&"
import script from "./TheAlgorithm.vue?vue&type=script&lang=js&"
export * from "./TheAlgorithm.vue?vue&type=script&lang=js&"
import style0 from "./TheAlgorithm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports